import styled from 'styled-components';
import AlertCard from '@gcc/pip-components/dist/alerts/cards/AlertCard';

export const OrderSummaryHeading = styled.h2`
  margin-top: 10px;
  margin-bottom: 10px;
  color: #333;
  font-weight: normal;
`;

export const OrderSummaryWrapper = styled.div`
  background-color: white;
  padding: 10px;
  min-height: 175px;
  margin: 15px 0;
`;

export const OrderSummaryPara = styled.div`
  font-size: 12px;
  margin: ${({ drawerStyles }) => (drawerStyles ? '0.625rem 0 -0.375rem 3.6rem' : '10px 0')};
  color: #333;
  font-weight: normal;
  display: flex;
  width: ${({ drawerStyles }) => (drawerStyles ? '86%' : '100%')};
`;

export const OrderSummaryLineItemThumbnail = styled.div`
  margin-right: 10px;
  & > img {
    width: 39px;
  }
`;

export const OrderSummaryNameWrapper = styled.div`
  flex-grow: 1;
`;
export const OrderSummaryName = styled.div`
  margin: ${({ noBottomMargin, isMobile, drawerStyles }) => {
    if (noBottomMargin) {
      return 0;
    }
    if (!noBottomMargin && isMobile && drawerStyles) {
      return '0 25px 10px 0';
    }
    return '0 0 10px 0';
  }};
  width: ${({ isMobile, drawerStyles }) => {
    if (isMobile && drawerStyles) {
      return '120px';
    }
    return '100%';
  }};
`;

export const SelectedOptions = styled.div`
  margin-bottom: ${({ noBottomMargin }) => (noBottomMargin ? 0 : '10px')};
  font-weight: 600;
`;
export const OrderSummaryRemoveFromOrder = styled.a`
  display: ${({ isMobile }) => (isMobile ? 'block' : 'inline')};
  margin-top: ${({ isMobile }) => (isMobile ? '10px' : 0)};
  color: #286fad;
  ${({ disabled }) =>
    disabled &&
    `
  cursor: not - allowed;
`}
`;
export const OrderSummaryQuantityWrapper = styled.div`
  width: ${({ isMobile, drawerStyles }) => {
    if (isMobile && !drawerStyles) {
      return '100%';
    }

    if (isMobile && drawerStyles) {
      return '25%';
    }
    return '64px';
  }};
  margin-left: ${({ isMobile }) => (isMobile ? 0 : '20px')}; ;
`;
export const OrderSummaryQuantityLabel = styled.div`
  margin-bottom: ${({ isMobile }) => (isMobile ? '4px' : '10px')};
  margin-top: ${({ isMobile, drawerStyles }) => {
    if (isMobile && !drawerStyles) {
      return '10px';
    }
    return 0;
  }};
`;
export const OrderSummaryQuantity = styled.span`
  font-weight: 600;
`;

export const OrderSummaryQuantityDrawer = styled.div`
  font-weight: 600;
  margin-top: 1rem;
`;
export const OrderSummaryPriceWrapper = styled.div`
  width: 70px;
`;
export const OrderSummaryPriceLabel = styled.div`
  margin-bottom: 10px;
  text-align: right;
`;
export const OrderSummaryPrice = styled.div`
  font-weight: 600;
  text-align: right;
`;
export const OrderSummaryPriceStrikethrough = styled.div`
  font-weight: 600;
  text-align: right;
  text-decoration: line-through;
`;
export const OrderSummaryPriceDiscount = styled.div`
  font-weight: 600;
  text-align: right;
  color: #00873c;
`;

export const ToastWrapper = styled.div`
  @media (min-width: 640px) {
    width: 50%;
    margin-left: -20px;
  }
  & > div {
    padding-top: 0;
    @media (min-width: 640px) {
      margin-left: 10px;
      margin-right: 10px;
    }
    @media (max-width: 639px) {
      margin-left: 0;
      margin-right: 0;
    }
  }
`;

export const ToastBodyWrapper = styled.div`
  @media (min-width: 640px) {
    margin-left: 10px;
  }
`;

export const TotalPriceLabel = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  min-width: 13%;
  margin-top: 10px;
  @media all and (max-width: 767px) {
    min-width: 23%;
  }
`;

export const TotalPriceValue = styled.div`
  font-size: 24px;
  font-weight: 600;
`;

export const TotalSavingsLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  color: #00873c;
  font-size: 12px;
  min-width: 13%;
  @media all and (max-width: 767px) {
    min-width: 23%;
  }
`;

export const TotalSavingsValue = styled.div`
  padding-left: 5px;
`;

export const AddToCartBtnContainer = styled.div`
  flex: 1;
  align-self: end;
`;

export const TotalPriceAndAddToCartContainer = styled.div`
  display: flex;
`;

export const TotalPriceAndSavingsContainer = styled.div`
  flex: 1;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
`;

export const TotalPriceContainer = styled.div``;

export const PriceCurrencySign = styled.span`
  font-size: 1.4rem;
  vertical-align: top;
  line-height: 21px;
`;

export const PriceDollars = styled.span`
  font-size: 2.4rem;
`;

export const PriceCents = styled.span`
  font-size: 1.4rem;
  vertical-align: top;
  line-height: 21px;
`;

export const DisableContainer = styled.div`
  width: 100%;
`;
export const AlertContainer = DisableContainer;

export const WarningMessage = styled(AlertCard)`
  width: 100%;
  padding: 0;
  @media all and (max-width: 767px) {
    font-size: 1.1rem;
  }
  & > div {
    padding: 10px;
  }
`;
